import { render } from "./MachinesList.vue?vue&type=template&id=07ceab07&ts=true"
import script from "./MachinesList.vue?vue&type=script&lang=ts"
export * from "./MachinesList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/AreaClienti_SELENIA/AreaClienti_SELENIA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__